import React, { ReactElement, useEffect, useRef, useState } from "react";
import MenuDots from '@mui/icons-material/MoreVert';
import { text_colors } from "../../../theme";
import { Delete } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

export const TagsList = ({ id, text, colorCode, onDelete, onEditTag }
  : { id: string, text: string, colorCode: string, onDelete: (id: string) => void, onEditTag: () => void }) => {

  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        padding: "10px 12px",
        justifyContent: "space-between",
        borderBottom: `1px solid ${text_colors.grey}`,
      }}
    >
      <Box style={{
        display: "flex",
        gap: 10,
        alignItems: "center",
      }}>
        <span style={{ width: "16px", height: "16px", backgroundColor: colorCode, borderRadius: "50%" }}>
        </span>
        <Typography>{text}</Typography>
      </Box>

      <MenuItemsDropDown
        menuButton={<MenuDots />}
        menuItems={[
          {
            label: "Delete",
            icon: <Delete fontSize="small" />,
            onClick: () => onDelete(id)
          },
          // {
          //   label: "Edit tag name",
          //   icon: <EditIcon fontSize="small" />,
          //   onClick: () => onEditTag()
          // }
        ]
        }
      />
    </Box>
  )
}

export const MenuItemsDropDown = ({ menuButton, menuItems }
  : { menuButton: ReactElement, menuItems: { label: string, icon?: ReactElement, onClick: () => void }[] }) => {

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
  }, []);

  return (
    <Box ref={dropdownRef} style={{ position: "relative" }}>
      <Box style={{
        cursor: "pointer"
      }} onClick={() => setIsOpen(!isOpen)}>{menuButton}</Box>
      {isOpen && (
        <Box style={{
          position: "absolute",
          top: "-43%",
          right: 30,
          backgroundColor: "white",
          borderRadius: "4px",
          padding: "6px",
          boxShadow: "0 2px 6px rgba(106, 105, 105, 0.19)",
          width: "180px",
          zIndex: 1
        }}>
          {menuItems.map((item, i) => (
            <Box style={{
              display: "flex", flexDirection: "row", padding: "8px 12px",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }} key={i}
              onClick={() => {
                item.onClick()
                setIsOpen(false)
              }}
            >
              {item.icon}
              <Typography>
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )

}